import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\GetInvoiceListController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceListController.php
* @route '/api/invoicing-dashboard'
*/
const GetInvoiceListController4d303451a855b15396e63125f291c94b = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetInvoiceListController4d303451a855b15396e63125f291c94b.url(options),
    method: 'post',
})

GetInvoiceListController4d303451a855b15396e63125f291c94b.definition = {
    methods: ["post"],
    url: '/api/invoicing-dashboard',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceListController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceListController.php
* @route '/api/invoicing-dashboard'
*/
GetInvoiceListController4d303451a855b15396e63125f291c94b.url = (options?: RouteQueryOptions) => {
    return GetInvoiceListController4d303451a855b15396e63125f291c94b.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceListController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceListController.php
* @route '/api/invoicing-dashboard'
*/
GetInvoiceListController4d303451a855b15396e63125f291c94b.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetInvoiceListController4d303451a855b15396e63125f291c94b.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceListController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceListController.php
* @route '/api/invoicing'
*/
const GetInvoiceListController6b1612eea066d74d74f76c2cbacc8ec8 = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceListController6b1612eea066d74d74f76c2cbacc8ec8.url(options),
    method: 'get',
})

GetInvoiceListController6b1612eea066d74d74f76c2cbacc8ec8.definition = {
    methods: ["get","head"],
    url: '/api/invoicing',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceListController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceListController.php
* @route '/api/invoicing'
*/
GetInvoiceListController6b1612eea066d74d74f76c2cbacc8ec8.url = (options?: RouteQueryOptions) => {
    return GetInvoiceListController6b1612eea066d74d74f76c2cbacc8ec8.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceListController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceListController.php
* @route '/api/invoicing'
*/
GetInvoiceListController6b1612eea066d74d74f76c2cbacc8ec8.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceListController6b1612eea066d74d74f76c2cbacc8ec8.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceListController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceListController.php
* @route '/api/invoicing'
*/
GetInvoiceListController6b1612eea066d74d74f76c2cbacc8ec8.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetInvoiceListController6b1612eea066d74d74f76c2cbacc8ec8.url(options),
    method: 'head',
})

/**
* Multiple routes resolve to \App\Http\Controllers\Invoice\GetInvoiceListController::GetInvoiceListController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `GetInvoiceListController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const GetInvoiceListController = {
    '/api/invoicing-dashboard': GetInvoiceListController4d303451a855b15396e63125f291c94b,
    '/api/invoicing': GetInvoiceListController6b1612eea066d74d74f76c2cbacc8ec8,
}

export default GetInvoiceListController